<script lang="ts">
  import { fade } from 'svelte/transition';
  import { getAppConfig } from '../../../common/config/app-config';
  import { getStr, isMobileWidth } from '../../../common/util';
  import { getServicesInfo, setPDPViewedServicesData } from '../services/pdp-data-services';
  import { openServicesInfoPopup } from '../store/pdp_store';
  import PdpExtraCoatingService from './PDPExtraCareCoatingService.svelte';
  import PdpExtraCareService from './PDPExtraCareService.svelte';
  import ExtraAppleCareService from './PDPExtraServices/ExtraAppleCareService.svelte';
  import PdpExtraSetupService from './PDPExtraSetupService.svelte';
  import PdpOtherService from './PDPOtherService.svelte';
  import PdpSafeguardService from './PDPSafeguardService.svelte';
  import PdpSectionCard from './PDPSectionCard.svelte';
  import PdpSplitAcService from './PDPSplitACService.svelte';

  const { productDetails } = getAppConfig();

  export let data: any;
  export let eligibleVasEntries: any;
  export let serviceType = '';
  const isResponsive = isMobileWidth();

  const appleCareTitleDetails =
    serviceType === 'appleCare' ? getLabelDataByCode(data?.servicesBlocks, 'servicesAppleCarePDPContent') : null;

  $: serviceTabList = populateServiceTabList(eligibleVasEntries, data?.servicesBlocks);
  let activeServiceTabIndex = null;

  function populateServiceTabList(eligibleVasEntries, servicesBlocks) {
    if (!eligibleVasEntries || eligibleVasEntries?.length <= 0) {
      setPDPViewedServicesData(null);
      return [];
    }

    const serviceTabList = eligibleVasEntries
      ?.map(vasEntry => {
        let code = 'servicesSafeguardPDPContent';
        if (vasEntry?.extraSetupService) code = 'extraServicesSetupPDPContent';
        else if (vasEntry?.splitAcService) code = 'servicesSetupPDPContent';
        else if (vasEntry?.appleCareService) code = 'servicesAppleCarePDPContent';
        else if (vasEntry?.extraCareCoating) code = 'servicesExtraCareCoatingPDPContent';
        else if (vasEntry?.extraCareService) code = 'servicesExtraCarePDPContent';
        return getLabelDataByCode(servicesBlocks, code);
      })
      ?.map(
        x =>
          (!x && {
            code: null,
            imageUrl: null,
            label: 'NO_SERVICE_BLOCK',
          }) ||
          x
      );

    activeServiceTabIndex = serviceTabList?.length > 0 ? 0 : null;

    // fill mixpanel data
    setPDPViewedServicesData(serviceTabList);

    return serviceTabList;
  }

  function getComponentData(vasEntry, servicesBlocks) {
    const componentData = {
      component: null,
      labelData: null,
      componentData: vasEntry,
      lmdConfigurations: data?.lmdConfigurations,
    };
    if (vasEntry?.extraSetupService) {
      componentData.component = PdpExtraSetupService;
      componentData.labelData = getLabelDataByCode(servicesBlocks, 'extraServicesSetupPDPContent');
    } else if (vasEntry?.splitAcService) {
      componentData.component = PdpSplitAcService;
      componentData.labelData = getLabelDataByCode(servicesBlocks, 'servicesSetupPDPContent');
    } else if (vasEntry?.appleCareService) {
      componentData.component = PdpOtherService;
      componentData.labelData = getLabelDataByCode(servicesBlocks, 'servicesAppleCarePDPContent');
      // this variable is used for other purpose, not for lmdConfigurations
      componentData.lmdConfigurations = ExtraAppleCareService;
    } else if (vasEntry?.extraCareCoating) {
      componentData.component = PdpExtraCoatingService;
      componentData.labelData = getLabelDataByCode(servicesBlocks, 'servicesExtraCareCoatingPDPContent');
    } else if (vasEntry?.extraCareService) {
      componentData.component = PdpExtraCareService;
      componentData.labelData = getLabelDataByCode(servicesBlocks, 'servicesExtraCarePDPContent');
    } else {
      // Todo: Add other services above as else if clauses...
      componentData.component = PdpSafeguardService;
      componentData.labelData = getLabelDataByCode(servicesBlocks, 'servicesSafeguardPDPContent');
      componentData.lmdConfigurations = null; // to avoid rendering it
    }

    return componentData;
  }
  function getLabelDataByCode(servicesBlocks, code) {
    return servicesBlocks.find(x => x.code === code);
  }
  function serviceTabClickHandler(e, index) {
    activeServiceTabIndex = index;
    if (!isResponsive) {
      return false;
    }
    const element = document.querySelector('.service-tab-list');
    element.scrollLeft = e.currentTarget?.getBoundingClientRect()?.left + element.scrollLeft - 22;
  }
  const serviceExploreAllClicked = () => {
    const serviceBlockTypes = eligibleVasEntries.map(service => service.serviceBlockType).join(',');
    getServicesInfo(productDetails.code, serviceBlockTypes, true);
    $openServicesInfoPopup = true;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
</script>

{#if eligibleVasEntries?.length > 0}
  <PdpSectionCard
    titleKey="extra.vas.service.safe.sound"
    subtitleKey="extra.vas.service.feel.free.pick.services"
    icon="icon-settings"
    {appleCareTitleDetails}
  >
    {#if serviceTabList?.length > 0}
      <section class="service-tab-list">
        <section class="service-tab-list-scroller">
          {#each serviceTabList as { code, imageUrl }, serviceTabIndex}
            <button
              class="service-tab"
              class:active={activeServiceTabIndex === serviceTabIndex}
              on:click={e => serviceTabClickHandler(e, serviceTabIndex)}
            >
              {#if imageUrl?.length > 0}
                <img src={imageUrl} alt={code} width="36" />
              {/if}
              <!-- <span class="label">{label}</span> -->
            </button>
          {/each}
        </section>
      </section>
      <!-- <a href="/check-all-services" class="check-all-services"
                >@Check all services</a
            > -->
    {/if}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    {#if eligibleVasEntries?.length > 1}
      <section class="services-explore-link" on:click={() => serviceExploreAllClicked()}>
        {getStr('extra.vas.explore.all.perks.label')}
      </section>
    {/if}
    <section class="service-list">
      {#each eligibleVasEntries as vasEntry, vasEntryIndex}
        {@const { component, labelData, componentData, lmdConfigurations } = getComponentData(
          vasEntry,
          data?.servicesBlocks
        )}
        {#if vasEntryIndex === activeServiceTabIndex}
          <section in:fade>
            <svelte:component this={component} data={componentData} {labelData} {lmdConfigurations} />
          </section>
        {/if}
      {/each}
    </section>
  </PdpSectionCard>
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .service-tab-list {
    overflow-x: auto;
    scrollbar-width: none;
  }
  .service-tab-list-scroller {
    display: flex;
    margin-block: 16px;
    gap: 12px;

    .service-tab {
      background: $primary-white;
      border: 1px solid $secondary-gray-02;
      border-radius: 12px;
      padding: 12px;
      flex-grow: 1;
      flex-shrink: 0;
      max-width: 234px;

      &.active {
        border-color: $primary-blue;
      }

      .label {
        margin-left: 8px;
        font-size: 12px;
        line-height: 18px;
        font-weight: 500;
        color: $neutral-dark-01;
      }
      img {
        width: auto;
        height: 36px;
      }
    }
  }
  .check-all-services {
    display: inline-block;
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
    margin-bottom: 16px;
  }
  .service-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .services-explore-link {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: $icon-only-icon-blue;
    margin-bottom: 15px;
    cursor: pointer;
  }
</style>
